import React from 'react'
import Tag from './tag'

const TagList = ({list, onRemove, renderValue, isClearable, hiddenSelectionOptionKeys, isFieldHeightFlexible}) => (
  <div className={`is-flex ${isClearable ? '' : 'tw:pr-2'}`} style={{overflow: 'hidden'}}>
    <div
      className={`ellipsis`}
      style={isFieldHeightFlexible ? {display: 'flex', flexWrap: 'wrap'} : {display: 'inline-table'}}
    >
      {list
        .filter(it => !hiddenSelectionOptionKeys.includes(it.key))
        .map((it, idx) => (
          <div key={idx} className="control tw:inline-block">
            <Tag idx={idx} item={it} renderValue={renderValue} onRemove={onRemove} />
          </div>
        ))}
    </div>
  </div>
)

export default React.memo(TagList)
